export function asyncSendToFriendModal() {
    return import(
        /* webpackChunkName: "asyncSendToFriendModal" */
        'dibs-send-to-friend-modal'
    ).then(mod => {
        return mod.default;
    });
}
